// extracted by mini-css-extract-plugin
export default {"headerWrap":"header_headerWrap__43DiD","logowrap":"header_logowrap__8bzwu","icons":"header_icons__5+CYL","headerRight":"header_headerRight__RfIm+"};